import {
  MenuItem,
  InputLabel,
  FormControl,
  Select,
  Box
} from '@material-ui/core'
import React, { ChangeEvent, useEffect, useRef } from 'react'

type IncidentV2DefaultFieldProps = {
  label: string
  getData?: (siteId: string, incidentTypeId: string) => Promise<void>
  siteId?: string
  incidentTypeId?: string
  selections?: any[]
  selectedValue?: string | number
  onChange: (value: string | number) => void
  disabled?: boolean
  required?: boolean
}

export const IncidentV2DefaultField = ({
  label,
  getData,
  siteId,
  incidentTypeId,
  selections = [],
  selectedValue,
  onChange,
  disabled,
  required
}: IncidentV2DefaultFieldProps) => {
  // Tracks which (siteId, incidentTypeId) pair has already been fetched.
  const fetchedKeyRef = useRef<string | undefined>(undefined)

  useEffect(() => {
    const key =
      siteId && incidentTypeId ? `${siteId}:${incidentTypeId}` : undefined
    if (getData && key && key !== fetchedKeyRef.current) {
      fetchedKeyRef.current = key
      getData(siteId as string, incidentTypeId as string)
    }
  }, [siteId, incidentTypeId])

  const handleChange = (
    event: ChangeEvent<{ name?: string | undefined; value: unknown }>
  ) => {
    onChange(event.target.value as string | number)
  }

  return (
    <Box style={{ padding: 40, paddingBottom: 16, paddingTop: 0 }}>
      <FormControl style={{ width: '100%' }}>
        <InputLabel
          id={`${label}-input-label`}
          style={required ? { color: '#f50057' } : {}}
        >
          {label}
        </InputLabel>
        <Select
          labelId={`${label}-input-label`}
          id={`${label}-select`}
          value={selectedValue || ''}
          onChange={handleChange}
          disabled={disabled}
        >
          {selections.map((selection, index) => (
            <MenuItem
              key={`${selection.label}-${index}`}
              value={
                selection.id ? selection.id : selection.value || selection.label
              }
              disabled={!!selection.disabled}
            >
              {selection.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
